$(function() {
    $(document).ready(function() {
        window.cart = [];
        $(document).on("click", ".js-add-to-card", function() {
            let data = {
                pid: $(this).closest(".profile-favourites__item").data("product")
            };
            sendAjax(data);
        })
        $(document).on("click", ".product-colors__item", function() {
            let data = {
                pid: $(this).data("product")
            };
            sendAjax(data)
        });

        $(document).on("click", ".sizes [data-size-button]", function() {
            $(this).closest('[data-product-size]').find('button').removeClass('active');
            $(this).addClass('active');
            let addBtn = $("#popup-cart").find("[data-add-to-basket]");
            let data = {
                id: $(this).data("id"),
                artnumber: $(this).data("art"),
                denied: $(this).data("denied")
            }

            if (window.cart.length && window.cart.includes(data.id)) {
                addBtn.html(window.pmMessages.goToCart).removeClass('disabled').addClass("basket-add");
            } else {
                addBtn.removeClass('disabled').html(window.pmMessages.addToCart).removeClass("basket-add");
                //checkReservation(data)
            }
        });

        $(document).on("click", "[data-add-to-basket]", function() {
            let selectedScu = $(".active[data-size-button]").data("id");
            if (selectedScu < 1 || typeof selectedScu === "undefined") {

            } else {
                if ($(this).hasClass("basket-add")) {
                    location.href = "/personal/cart/";
                } else {
                    let data = {
                        sessid: BX.bitrix_sessid(),
                        action: 'ADD2BASKET',
                        quantity: 1,
                        id: selectedScu,
                    }
                    addToBasket(data)
                }
            }
        });
    })

    function sendAjax(data)
    {
        if (window.xhr_quick_view && window.xhr_quick_view.readyState != 4) {
            window.xhr_quick_view.abort();
        }
        window.xhr_quick_view = $.post("/local/ajax/quick_view.php", data, function(_response) {
            window.cart = _response.basket;
            let popup = $("#popup-cart");
            let slides = createSlider(_response);
            let addBtn = popup.find("[data-add-to-basket]").removeClass("disabled basket-add").html(window.pmMessages.addToCart);

            popup.find(".slider-cart--popup .swiper-wrapper").empty()
            popup.find(".slider-cart--popup .swiper-wrapper").append(slides);

            let sizes = createSizes(_response);
            popup.find("[data-product-size]").empty().append(sizes);
            let cart = new Cart($("[data-product-size]"));
            cart.initialize();


            let colors = createSameModels(_response);
            popup.find(".js-colors-items").empty().append(colors);

            popup.find(".product__title").html(_response.name);
            popup.find(".product__title").next("p").html(_response.sectionName);
            popup.find(".js-points-value").html(_response.bonus)
            popup.find(".js-color-value").html(_response.color)
            popup.find(".js-card-value").html(_response.priceWithSale)
            popup.find(".price__current").html(_response.price)
            if (_response.basePrice.length > 0) {
                popup.find(".price__old").removeClass("hidden")
                popup.find(".price__old").html(_response.basePrice)
            } else {
                popup.find(".price__old").addClass("hidden")
            }

            if (_response.availableSizes === false || _response.isPreOrder) {
                showNotify()
            } else {
                hideNotify()
            }

            let notifyName = _response.name;

            $("#form-subscribe-product").find('input[name="notify_product_name"]').val(notifyName);

            $.magnificPopup.open({
                items: {
                    src: '#popup-cart'
                },
                type: 'inline',
                midClick: true,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                removalDelay: 500, //delay removal by X to allow out-animation
                callbacks: {
                    beforeOpen: function() {
                        this.st.mainClass = 'mfp-right-left';
                    }
                }
            });

            let images = popup.find(".lazyload");
            let lazy = new LazyLoad(images);
            lazy.loadImages();
            //
            let slider = new Slider(popup.find("[data-slider]"));
            slider.initialize();

        }, 'json');
    }

    function createSlider(data)
    {

        let container = "";
        for (let id in data.photos) {
            let photo = data.photos[id];
            let swiperSlide = $("<div>").addClass("slider-cart__slide swiper-slide col-12").attr("dataindex", id);
            let cartImages = $("<div>").addClass("slider-cart__images")
            let img = $("<img>").addClass("lazyload slider-cart__img load").attr({
                src: "/local/frontend/build/assets/images/example/load.webp",
                width: "1",
                height: "1",
                "data-src": photo
            });
            swiperSlide.append(cartImages.append(img));
            container += swiperSlide[0].outerHTML;
        }
        return container;
    }

    function createSizes(data)
    {
        let container = "";
        let countAllOffers = 0;
        let countNotAllowedOffers = 0;
        for (let id in data.offers) {
            countAllOffers++;
            let offer = data.offers[id];
            let sizeItem = $("<div>").addClass("sizes__item tooltip__wrap");
            let sizeBtn = $("<button>").addClass("btn-light btn-light--xs").attr({
                "data-size-button": "",
                "data-id": offer.id,
                "data-art": offer.artnumber,
                "data-denied": offer.denied
            }).html(offer.size.RU);
            if (!offer.allowed) {
                sizeBtn.attr("disabled", "");
                sizeItem.addClass('d-none')
                countNotAllowedOffers++;
            }
            if (offer.size.EU != null && offer.size.US != null) {
                let tooltip = $("<div>").addClass("tooltip").attr("data-tooltip", "");
                let tooltipInner = $("<div>").addClass("tooltip__inner");
                let tooltipItemEU = $("<div>").addClass("tooltip__item").html(`EU:<b>${offer.size.EU}</b>`);
                let tooltipItemRU = $("<div>").addClass("tooltip__item").html(`US:<b>${offer.size.US}</b>`);
                let tooltipSvg = $("<div>").addClass("tooltip__item").html(' <svg class="icon foot " aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#foot"></use></svg> ' + offer.size.length)
                tooltip.append(tooltipInner.append(tooltipItemEU, tooltipItemRU, tooltipSvg))
                sizeItem.append(sizeBtn, tooltip)
            } else {
                sizeItem.append(sizeBtn)
            }


            container += sizeItem[0].outerHTML
        }

        if (countAllOffers - countNotAllowedOffers <= 0) {
            $('[data-size-title]').addClass('d-none')
            $('[data-sizes-button]').addClass('d-none')
        } else {
            $('[data-size-title]').removeClass('d-none')
            $('[data-sizes-button]').removeClass('d-none')
        }

        return container;
    }

    function createSameModels(data)
    {
        let productId = data.id;
        let container = "";
        for (let id in data.same) {
            let model = data.same[id];
            let productColor = $("<a>").addClass("product-colors__item").attr({
                "href": "#",
                "data-product": model.id
            });
            if (productId === model.id) {
                productColor.addClass("active");
            }
            let productImageContainer = $("<div>").addClass("product-colors__images");
            let img = $("<img>").addClass("lazyload").attr({
                src: "/local/frontend/build/assets/images/example/load.webp",
                width: "1",
                height: "1",
                "data-src": model.photo
            });
            productColor.append(productImageContainer.append(img))
            container += productColor[0].outerHTML
        }
        return container;
    }

    function checkReservation(data)
    {

        if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').show();
        }
        if (window.xhr_reservation_info && window.xhr_reservation_info.readyState != 4) {
            window.xhr_reservation_info.abort();
        }
        window.xhr_reservation_info = $.post("/local/ajax/reservation_info.php", data, function(_response) {
            window.savedSizes = _response['SAVED_SIZES'];
            let addBtn = $("#popup-cart").find("[data-add-to-basket]");
            if (_response['DELIVERY'] != 'Y' && !_response['SHOPS'].length && _response['DAY_DELIVERY'] != 'Y') {
                $("#form-subscribe-product").find('input[name="sku_id"]').val(data.id);
                showNotify();
            } else {
                hideNotify();
            }
            if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').hide();
            }
        }, 'json');
    }

    function addToBasket(data)
    {
        if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').show();
        }
        if (window.xhr_addtobasket && window.xhr_addtobasket.readyState != 4) {
            window.xhr_addtobasket.abort();
        }
        window.xhr_addtobasket = $.post("/local/ajax/addtobasket.php", data, function(_response) {

            // закроем попап с детальной информацией о товаре
            let popupInstance = $.magnificPopup.instance;
            popupInstance.close();

            // обновление корзины в хедере при добавлении товара
            let minicart = [];
            if ($('[data-header-cart]').length > 0) {
                $('[data-header-cart]').each(function(i) {
                    minicart[i] = new Cart($(this));
                    minicart[i].refreshMiniCart();
                });
            }
            $("#popup-cart").find("[data-add-to-basket]").html(window.pmMessages.goToCart).addClass('basket-add');
            if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').hide();
            }

            // Retail Rocket
            if (typeof window.stock_id != 'undefined') {
                try {
                    rrApi.addToBasket(parseInt(data.id), {stockId: window.stock_id})
                } catch (e) {
                }
            }

            // gtm, flocktory
            if (typeof window.gtm_items !== 'undefined') {
                let item_gtm = window.gtm_items.find((item) => {
                    return item.id == data.id;
                });
                if (typeof item_gtm !== 'undefined') {
                    window.flocktory = window.flocktory || [];
                    window.flocktory.push([
                        'addToCart', {
                            item: {
                                'id': item_gtm.id,
                                'count': data.quantity,
                                'price': item_gtm.price,
                            }
                        }
                    ])

                    dataLayer.push({
                        'event': 'add_to_cart',
                        'items': [
                            {
                                'google_business_vertical': 'retail',
                                'id': item_gtm.id,
                            }
                        ]
                    });
                    dataLayer.push({
                        'ecommerce': {
                            'currencyCode': 'KZT',
                            'add': {
                                'products': [
                                    {
                                        'name': item_gtm.name,
                                        'id': item_gtm.id,
                                        'price': item_gtm.price,
                                        'brand': item_gtm.brand,
                                        'category': item_gtm.category,
                                        'variant': item_gtm.variant,
                                        'quantity': data.quantity,
                                    }
                                ]
                            }
                        },
                        'event': 'gtm-ee-event',
                        'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
                        'gtm-ee-event-category': 'Enhanced Ecommerce',
                        'gtm-ee-event-non-interaction': 'False',
                    });
                }
            }
        }, 'json');
    }

    function showNotify()
    {
        let popup = $("#popup-cart");
        popup.find(".notify-btn").show();
        popup.find(".add-btn").hide().addClass("disabled");
    }

    function hideNotify()
    {
        let popup = $("#popup-cart");
        popup.find(".notify-btn").hide();
        popup.find(".add-btn").show().removeClass("disabled");
    }
})
